export default "<p>\n  root works!\n</p>"